<template>
    <div class="page_nation tab-panel1">
        <ul class="pagination-tab-group">
            <!-- 最初のページ ※現在が最初のページなら無効 -->
            <li class="page_nation__pre2">
                <span v-if="projects_data.current_page === 1" class="inactive"></span>
                <a v-else :href="`${link_url}&page=1`"></a>
            </li>
            <!-- １ページ前のページ ※現在が最初のページなら無効 -->
            <li class="page_nation__pre1">
                <span v-if="projects_data.current_page === 1" class="inactive"></span>
                <a v-else :href="`${link_url}&page=${projects_data.current_page - 1}`"></a>
            </li>
            <!-- ページのリスト -->
            <li v-for="(page, index) in page_list" :key="index" class="page_nation__num">
                <span
                    class="inactive"
                    v-if="page == current_page">
                    <span>{{ page }}</span>
                </span>
                <a v-else :href="`${link_url}&page=${page}`">{{ page }}</a>
            </li>
            <!-- １ページ後ろのページ ※現在が最後のページなら無効 -->
            <li class="page_nation__aft1">
                <span v-if="projects_data.current_page >= projects_data.last_page" class="inactive"></span>
                <a v-else :href="`${link_url}&page=${projects_data.current_page + 1}`"></a>
            </li>
            <!-- 最後のページ -->
            <li class="page_nation__aft2">
                <span v-if="projects_data.current_page >= projects_data.last_page" class="inactive"></span>
                <a v-else :href="`${link_url}&page=${projects_data.last_page}`"></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        // 案件情報（ページング含む）
        'projects_data': {
            type: Object,
            required: true,
        },
        // 最大ページネーション表示数
        'paginate_link_num': {
            type: Number,
            required: true,
        },
        // リンク先のURL
        'link_url': {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            page_list: [],
            current_page: 0,
            start_page: 0,
            end_page: 0,
        };
    },

    created() {
        this.setPaginationLinks()
    },

    methods: {
        setPaginationLinks: function()
        {

            const links = this.projects_data.links
            links.shift()
            links.pop()

            if (this.projects_data.last_page > this.paginate_link_num) {
                // 現在ページが表示するリンクの中心位置よりも左の時
                if (this.projects_data.current_page <= Math.floor(this.paginate_link_num) / 2) {
                    this.start_page = 1; //最初のページ
                    this.end_page = this.paginate_link_num;
                // 現在ページが表示するリンクの中心位置よりも右の時
                } else if (this.projects_data.current_page > this.projects_data.last_page - Math.floor(this.paginate_link_num) / 2) {
                    this.start_page = this.projects_data.last_page - (this.paginate_link_num - 1)
                    this.end_page = this.projects_data.last_page;
                } else {
                    this.start_page = this.projects_data.current_page - (Math.floor((this.paginate_link_num) % 2 == 0 ? this.paginate_link_num - 1 : this.paginate_link_num)  / 2)
                    this.end_page = this.projects_data.current_page + Math.floor(this.paginate_link_num) / 2;
                }
            } else {
                this.start_page = 1;
                this.end_page = this.projects_data.last_page
            }

            this.current_page = this.projects_data.current_page

            for (let i = Math.ceil(this.start_page); i <= Math.floor(this.end_page); i++ ) {
                this.page_list.push(i);
            }
        },
    },
};
</script>
